import axios from 'axios';
import React, { Component } from "react";
// reactstrap components
// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Modal,
  Button,
  Form,
  FormGroup,
  Input,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import ReactQuill from "react-quill";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import { truncateText } from '../../../../utils/ccl-utils';

// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
// connect
import connect from 'redux-connect-decorator';
import { getQuestions, removeQuestion, saveOrUpdate } from '../../../../actions/questionActions';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { toast } from 'react-toastify';
import isEmpty from '../../../../utils/is-empty';
import { pagination } from '../../../../utils/ccl-utils';

const { SearchBar } = Search;

const allUpperCase = (cell, row) => {
  return <span>{cell.toUpperCase()}</span>;
}

const allBold = (cell, row) => {
  return <b>{cell}</b>;
}

const formatText = (cell, row) => {
  return truncateText(cell.replace(/<[^>]+>/g, ''), 80);
}

const allItalic = (cell, row) => {
  return <i>{cell}</i>;
}

@connect(
  state => ({
    questions: state.question.questions,
    loading: state.question.loading
  }),
  {
    getQuestions
  }
)
class Question extends Component<any, any> {
  upload;
  state = {
    _id: null,
    selectedData: null,
    defaultModal: null,
    topic: null,
    text: null,
    exam_name: null,
    solution: null,
    answer_a: null,
    answer_b: null,
    answer_c: null,
    answer_d: null,
    answer_e: null,
    answer_f: null,
    answer_g: null,
    answer_h: null,
    answer_i: null,
    answer_j: null,
  }

  componentDidMount() {
    this.props.getQuestions();
  }

  constructor(props) {
    super(props);
    this.upload = React.createRef();
  }

  resetState = () => {
    this.setState({
      _id: null,
      selectedData: null,
      defaultModal: null,
      topic: null,
      text: null,
      exam_name: null,
      solution: null,
      answer_a: null,
      answer_b: null,
      answer_c: null,
      answer_d: null,
      answer_e: null,
      answer_f: null,
      answer_g: null,
      answer_h: null,
      answer_i: null,
      answer_j: null,
    });
  }

  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };

  onSave = async () => {
    console.log(`onSave`, this.state);
    if (isEmpty(this.state.topic) || isEmpty(this.state.exam_name) || isEmpty(this.state.text) || isEmpty(this.state.solution)) {
      toast.error('Nhập đủ thông tin trước khi tiếp tục');
      return;
    }
    let data = { ...this.state};

    const result = await saveOrUpdate(data);
    if (result && result.status == 200) {
      this.props.getQuestions();
      toast.success('Add or update question success.');
      this.toggleModal("defaultModal");
    }
  }

  addNew = () => {
    // reset
    this.resetState();
    // logic
    this.toggleModal("defaultModal");
  }

  edit = (e, row) => {
    e.preventDefault();
    // reset
    this.resetState();
    this.setState({
      ...row,
      selectedData: row
    });
    // logic
    this.toggleModal("defaultModal");
  }

  onDelete = async (row) => {
    const result = await removeQuestion(row._id);
    // Load user again
    if (result && result.status == 200) {
      this.props.getQuestions();
      toast.success('Delete question success.');
    }
  }


  confirmDelete = (e, row) => {
    e.preventDefault();
    confirmAlert({
      title: 'Confirm to delete',
      message: `Are you sure to delete this question?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.onDelete(row)
        },
        {
          label: 'No',
          onClick: null
        }
      ]
    });
  }

  onFileChangeHandler = (e) => {
    // Upload
    const data = new FormData();
    data.append('file', e.target.files[0]);
    axios.post("/api/question/import", data, { 
          // receive two    parameter endpoint url ,form data
      })
      .then(res => { // then print response status
        console.log(res.statusText);
        this.props.getQuestions();
        toast.success('Import questions success.');
      })
  }

  addActionButton = (cell, row) => {
    return (
        <div className="table-actions">
            <a
              className="table-action table-action-play"
              href="#"
              id="tooltip123539273"
              onClick={e => this.edit(e, row)}
            >
              <i className="fas fa-edit" />
            </a>
            <UncontrolledTooltip delay={0} target="tooltip123539273">
              Edit
            </UncontrolledTooltip>
            <a
              className="table-action table-action-transcript"
              href="#"
              id="tooltip397466356"
              onClick={e => this.confirmDelete(e, row)}
            >
              <i className="fas fa-trash-alt" />
            </a>
            <UncontrolledTooltip delay={0} target="tooltip397466356">
              Delete
            </UncontrolledTooltip>
        </div>
    )
  }
  render() {
    const { questions, loading } = this.props;
    return (
      <>
        <SimpleHeader name="Question" parentName="Management" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader>
                  <Button 
                    className="btn btn-info btn-sm"
                    onClick={this.addNew}
                  >Add new</Button>

                  <Button
                      className="btn-benit-sm btn-benit-blue benit-try-again"
                      type="button"
                      onClick= { () => { this.upload.current.click() }}
                    >
                    <span className="btn-inner--text hidden-lg-down">Import&nbsp;&nbsp;</span>
                    <span className="btn-inner--icon mr-1">
                      <i className="far fa-file-excel"></i>
                    </span>
                  </Button>
                  <p className="text-sm mb-0"></p>
                  
                  <div style={{ position: 'absolute',  right: '0px', top: '0px'}}>
                    <div className="custom-file" style={{ display: 'none'}}>
                      <input type="file" name="file-image" 
                      ref={ this.upload }
                      // ref={(ref) => this.upload = ref}
                      onChange={e => this.onFileChangeHandler(e)} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                    </div>
                  </div>
                </CardHeader>
                { questions && <ToolkitProvider
                  data={ questions }
                  keyField="_id"
                  columns={[
                    {
                      dataField: "topic",
                      text: "Topic",
                      sort: true,
                      formatter: allUpperCase
                    },
                    {
                      dataField: "exam_name",
                      text: "Exam name",
                      sort: true,
                      formatter: allUpperCase
                    },
                    {
                      dataField: "text",
                      text: "Text",
                      sort: true,
                      formatter: formatText
                    },
                    {
                      dataField: "solution",
                      text: "Solution",
                      sort: true,
                      formatter: allBold
                    },
                    {
                      dataField: "action",
                      text: "Action",
                      searchable: false,
                      sort: false,
                      formatter: this.addActionButton
                    }
                  ]}
                  search
                >
                  {props => (
                    <div className="py-4 table-responsive align-items-center table-flush table">
                      <div
                        id="datatable-basic_filter"
                        className="dataTables_filter px-4 pb-1"
                      >
                        <label>
                          Search:
                          <SearchBar
                            className="form-control-sm"
                            placeholder=""
                            {...props.searchProps}
                          />
                        </label>
                      </div>
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={false}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                }
              </Card>
            </div>
          </Row>

          <Modal
              className="modal-dialog-centered modal-lg"
              isOpen={this.state.defaultModal}
              toggle={() => this.toggleModal("defaultModal")}
            >
              <div className="modal-header">
                <h6 className="modal-title" id="modal-title-default">
                  <div>Question : { this.state.selectedData ? 'Edit' : 'New'}</div>
                  <small></small>
                </h6>
                <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("defaultModal")}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>
              <div className="modal-body mt--4">
                <Form className="mt--2">
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input1">
                          Topic
                        </label>
                        <Input id="input1" 
                          defaultValue={ this.state.topic} 
                          onChange={ e => this.setState({ topic: e.target.value }) } 
                          placeholder="Topic" 
                          type="text" />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input1a">
                          Exam name
                        </label>
                        <Input id="input1a" 
                          defaultValue={ this.state.exam_name} 
                          onChange={ e => this.setState({ exam_name: e.target.value }) } 
                          placeholder="Exam name" 
                          type="text" />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="12">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input2">
                          Text
                        </label>
                        {/* <Input id="input2" 
                          defaultValue={ this.state.text} 
                          onChange={ e => this.setState({ text: e.target.value }) } 
                          placeholder="Text question" 
                          rows="3"
                          type="textarea" /> */}
                        <ReactQuill
                          value={this.state.text}
                          onChange={ value => this.setState({ text: value })}
                          theme="snow"
                          modules={{
                            toolbar: [
                              ["bold", "italic"],
                              ["blockquote", "code"],
                              [
                                {
                                  list: "ordered"
                                },
                                {
                                  list: "bullet"
                                }
                              ]
                            ]
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="12">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input2">
                        Answer
                      </label>
                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          defaultChecked={ this.state.solution === 'A' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          id="customRadioa"
                          value="A"
                          name="radio-answer"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadioa"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_a" 
                            defaultValue={ this.state.answer_a} 
                            onChange={ e => this.setState({ answer_a: e.target.value }) } 
                            placeholder="Answer A" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>
                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          id="customRadiob"
                          defaultChecked={ this.state.solution === 'B' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          value="B"
                          name="radio-answer"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadiob"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_b" 
                            defaultValue={ this.state.answer_b} 
                            onChange={ e => this.setState({ answer_b: e.target.value }) } 
                            placeholder="Answer B" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>
                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          id="customRadioc"
                          defaultChecked={ this.state.solution === 'C' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          value="C"
                          name="radio-answer"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadioc"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_c" 
                            defaultValue={ this.state.answer_c} 
                            onChange={ e => this.setState({ answer_c: e.target.value }) } 
                            placeholder="Answer C" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>
                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          id="customRadiod"
                          name="radio-answer"
                          defaultChecked={ this.state.solution === 'D' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          value="D"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadiod"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_d" 
                            defaultValue={ this.state.answer_d} 
                            onChange={ e => this.setState({ answer_d: e.target.value }) } 
                            placeholder="Answer D" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>
                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          id="customRadioe"
                          name="radio-answer"
                          defaultChecked={ this.state.solution === 'E' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          value="E"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadioe"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_e" 
                            defaultValue={ this.state.answer_e} 
                            onChange={ e => this.setState({ answer_e: e.target.value }) } 
                            placeholder="Answer E" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>

                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          id="customRadiof"
                          name="radio-answer"
                          defaultChecked={ this.state.solution === 'F' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          value="F"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadiof"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_f" 
                            defaultValue={ this.state.answer_f} 
                            onChange={ e => this.setState({ answer_f: e.target.value }) } 
                            placeholder="Answer F" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>

                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          id="customRadiog"
                          name="radio-answer"
                          defaultChecked={ this.state.solution === 'G' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          value="G"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadiog"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_g" 
                            defaultValue={ this.state.answer_g} 
                            onChange={ e => this.setState({ answer_g: e.target.value }) } 
                            placeholder="Answer G" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>

                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          id="customRadioh"
                          name="radio-answer"
                          defaultChecked={ this.state.solution === 'H' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          value="H"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadioh"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_h" 
                            defaultValue={ this.state.answer_h} 
                            onChange={ e => this.setState({ answer_h: e.target.value }) } 
                            placeholder="Answer H" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>

                      <div className="custom-control custom-radio mb-3">
                        <input
                          className="custom-control-input"
                          id="customRadioi"
                          name="radio-answer"
                          defaultChecked={ this.state.solution === 'I' }
                          onChange={e => this.setState({ solution: e.target.value })} 
                          value="I"
                          type="radio"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadioi"
                        >
                        </label>
                        <div style={{ marginTop: '-32px'}}>
                          <Input id="input_answer_i" 
                            defaultValue={ this.state.answer_i} 
                            onChange={ e => this.setState({ answer_i: e.target.value }) } 
                            placeholder="Answer I" 
                            className="text-dark"
                            type="text" />
                        </div>
                      </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </div>
              <div className="modal-footer">
                <Button 
                  disabled={ !(this.state.topic && this.state.text && this.state.solution) }
                  color="primary" type="button" onClick={this.onSave}>
                  Save changes
                </Button>
                <Button
                  className="ml-auto"
                  color="link"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("defaultModal")}
                >
                  Close
                </Button>
              </div>
            </Modal>
        </Container>
      </>
    );
  }
}

export default Question;
